import AddInterpreter from 'components/interpreter/AddInterpreter'
import React from 'react'
import { useNavigate } from 'react-router-dom';

const InterpreterCreate = () => {
    const navigate = useNavigate();

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className={`main_heading`}>Create Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>
            <AddInterpreter />
        </div>
    )
}

export default InterpreterCreate